/**
 * Compare two values for sorting
 *
 * @param aValue The first value to compare
 * @param bValue The second value to compare
 * @param ascending Whether to sort ascending
 * @returns The sort order
 * @throws TypeError An error if the types are not supported
 */
export function compareForSort(aValue, bValue, ascending = true) {
    let diff = 0;
    if (aValue && !bValue) {
        diff = 1;
    }
    else if (!aValue && bValue) {
        diff = -1;
    }
    else if (!aValue && !bValue) {
        diff = 0;
    }
    else {
        if (typeof aValue === "string" && typeof bValue === "string") {
            diff = aValue.localeCompare(bValue);
        }
        else if (typeof aValue === "number" && typeof bValue === "number") {
            diff = aValue - bValue;
        }
        else if (aValue instanceof Date && bValue instanceof Date) {
            diff = aValue.getTime() - bValue.getTime();
        }
        else if (typeof aValue === "boolean" && typeof bValue === "boolean") {
            diff = 0; //These are both true if we get here.
        }
        else {
            throw new TypeError(`Unsupported types for sorting: A type: "${typeof aValue}" A Value: "${aValue}" B Type: "${typeof bValue}" && B Value: "${bValue}"`);
        }
    }
    if (ascending) {
        return diff;
    }
    return Object.is(-diff, -0) ? 0 : -diff;
}
/**
 * Compare two objects for sorting by a field
 *
 * @template T The type of the objects
 * @param a The first object to compare
 * @param b The second object to compare
 * @param field The field to compare by
 * @param ascending Whether to sort ascending
 * @returns The sort order
 */
export function compareForSortByField(a, b, field, ascending = true) {
    return compareForSort(a[field], b[field], ascending);
}
/**
 * Sort an array of objects by a field
 *
 * @template T The type of the objects
 * @param rows The rows to sort
 * @param field The field to sort by
 * @param ascending Whether to sort ascending
 * @returns The sorted rows
 */
export function sortOnField(rows, field, ascending = true) {
    return rows
        .slice()
        .sort((a, b) => compareForSortByField(a, b, field, ascending));
}
//# sourceMappingURL=sorting.js.map